var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEtherscanLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    width: 20,
    height: 20,
    viewBox: "0 0 2500 2500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    d: "M520.6,1188.9c0-57.7,47.4-105.1,105-105.1l0,0h177.1c57.7,0,107.1,47.4,107.1,107.2l0,0v667.9     c20.6-6.2,45.3-12.4,74.2-18.6c39.1-10.3,68-45.3,68-86.6V925c0-57.7,47.4-107.2,107.1-107.2h177.1     c57.7,0,107.1,47.4,107.1,107.2V1694c0,0,43.3-18.6,86.5-37.1c33-14.4,53.6-45.3,53.6-82.5V657.1c0-57.7,47.4-107.2,105.1-107.2     h177.1c57.7,0,105.1,47.4,105.1,107.2v756.6c152.4-111.3,309-245.3,432.6-406.1c37.1-47.4,47.4-109.3,26.8-167     c-226.6-651.4-939.2-997.8-1590.1-771s-996.9,940-770.4,1591.5c24.7,74.2,57.7,144.3,96.8,212.3c30.9,53.6,88.6,84.5,150.4,78.3     c33-2.1,74.2-6.2,125.6-12.4c45.3-4.1,78.3-43.3,78.3-88.7L520.6,1188.9L520.6,1188.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M516.4,2260.9c558.2,406.1,1338.9,282.4,1744.6-276.2c154.5-214.4,238.9-472.1,238.9-735.9     c0-28.9-2.1-57.7-4.1-86.6C2040.7,1844.5,1198.2,2164,516.4,2260.9L516.4,2260.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtherscanLogo);
export default __webpack_public_path__ + "static/media/etherscan-logo.fc376b21f6bb8cf5d5304d02d06c09d6.svg";
export { ForwardRef as ReactComponent };